module.exports = __webpack_public_path__ + "img/dateline_2.7209f1bf.png";